// The map's pin layers (MapController adds them), for the code that reads what they draw.
export const PIN_LAYERS = ["primary-pins", "secondary-pins", "thin-pins", "single-pins"] as const;
export const GROUP_LAYER = "primary-clusters";
/** How near pins group (px, the primary source's clusterRadius); hover.ts finds an event's group within two of these. */
export const CLUSTER_RADIUS = 48;
